<template>
  <footer class="m-footer">
    <ul class="bottom-ul" style="line-height: 30px">
      <li>
        <a class="link" href="https://jbts.mct.gov.cn/home" target="_blank">
          文化市场举报投诉
        </a>
        ｜
        <a class="link" href="https://www.12377.cn/" target="_blank">
          违法和不良信息举报中心
        </a>
        ｜
        <a class="link" @click="isModal = true">技术监管条例</a>
      </li>
      <br />
      <li>Copyright © 2024 {{ icpData.name }} ￨</li>
      <li>
        <a class="link" href="http://beian.miit.gov.cn/" target="_blank">
          <!-- 浙ICP备2022035194号-2 -->
          {{ icpData.icp }}
        </a>
        <!-- ￨ -->
      </li>

      <!-- <li>
        <a class="link" href="https://vlive-static.vlebo.cn/wangwen.jpg" target="_blank">
          浙网文(2024)1392-064号
        </a>
      </li> -->
      <br />
      <li style="text-align: center">
        投诉通道：电话(400-6256-888) 、邮箱(vlive@vlebo.cn)、
        文旅厅投诉举报电话：12345
      </li>
    </ul>
    <Modal v-model="isModal" title="技术监管条例" width="800">
      <div class="content">
        第一章 总则 ​
        <br />
        第一条 立法目的与依据​
        <br />
        为加强技术监管工作的规范化、系统化和科学化，保障技术活动的安全性、合规性与质量可靠性，维护市场公平竞争秩序，保护公众权益与社会公共利益，促进技术创新与产业高质量发展，根据《中华人民共和国民法典》及相关法律法规，制定本条例。​
        <br />
        第二条 适用范围​
        <br />
        本条例适用于中华人民共和国境内所有涉及技术标准实施、质量控制、风险防控的技术活动及其监督管理，涵盖以下领域与对象：​
        <br />
        产品与技术设备：工业制品、电子产品、机械设备、建筑材料等各类流通产品的技术性能与质量管控；​
        <br />
        服务行业：餐饮、医疗、教育、信息技术等公共服务与商业服务的技术标准执行与质量评估；​
        <br />
        工程项目：工程建设的设计、施工、验收等环节的技术合规性与安全保障；​
        <br />
        技术创新活动：新技术、新工艺、新材料的研发、试验、转化及应用全过程的风险防控与质量评价。​
        <br />
        第三条 基本原则​
        <br />
        合法性原则：监管活动严格遵循法律法规，确保监管主体合法、程序合规、措施法定；​
        <br />
        科学性原则：以科学理论与方法为支撑，采用先进技术手段，保障监管结果准确可靠；​
        <br />
        公正性原则：监管主体独立于生产经营活动，坚持客观中立，维护监管的权威性与公信力；​
        <br />
        全面性与预防性原则：覆盖技术活动全链条（研发、生产、流通、使用），强化风险识别与预警，提前消除安全隐患；​
        <br />
        服务发展原则：兼顾监管与服务，通过规范引导技术进步，为产业转型升级提供支撑；​
        <br />
        社会共治原则：鼓励企业自律、行业协同、公众参与与舆论监督，构建多元共治的监管体系。​
        <br />
        第四条 法律地位​
        科学性原则：以科学理论与方法为支撑，采用先进技术手段，保障监管结果准确可靠；​
        <br />
        公正性原则：监管主体独立于生产经营活动，坚持客观中立，维护监管的权威性与公信力；​
        <br />
        全面性与预防性原则：覆盖技术活动全链条（研发、生产、流通、使用），强化风险识别与预警，提前消除安全隐患；​
        <br />
        服务发展原则：兼顾监管与服务，通过规范引导技术进步，为产业转型升级提供支撑；​
        <br />
        社会共治原则：鼓励企业自律、行业协同、公众参与与舆论监督，构建多元共治的监管体系。​
        <br />
        第四条 法律地位​
        <br />
        技术监管是社会公共事务管理的法定组成部分，监管机构依法独立行使职能，其作出的监管决定具有法律效力，相关单位与个人应当予以配合执行。​
        <br />
        第二章 监管主体与职责​
        <br />
        第五条 监管体系构成​
        <br />
        行政监管部门：县级以上人民政府设立的技术监管主管部门，统筹本行政区域内技术监管工作，负责政策制定、统筹协调与执法监督；​
        <br />
        专业技术机构：经认证的检验检测机构、技术评估机构等，承担抽样检测、风险评估、标准验证等技术支撑工作；​
        <br />
        行业组织：相关行业协会、商会等，制定行业技术规范，开展自律监管与合规培训；​
        <br />
        被监管单位：履行主体责任，建立内部技术管控体系，接受并配合外部监管。​
        <br />
        第六条 行政监管部门职责​
        <br />
        组织制定并修订地方技术标准与监管细则，推动国家及行业标准的实施；​
        <br />
        制定年度监管计划，明确监管重点领域、频次与措施；​
        <br />
        开展监督检查、违法违规行为查处及重大技术事故调查；​
        <br />
        建立监管信息平台，公开监管标准、流程与结果；​
        <br />
        提供技术咨询与培训服务，推动技术创新成果转化；​
        <br />
        协调跨区域、跨部门监管协作，建立信息共享机制。​
        <br />
        第七条 专业技术机构职责​
        <br />
        按照法定标准与程序开展检验检测、认证评价，出具客观真实的技术报告；​
        <br />
        参与技术风险监测与预警，为监管决策提供数据支撑；​
        <br />
        保守被监管单位的商业秘密与技术秘密；​
        <br />
        定期向监管部门报送技术分析报告与风险提示。​
        <br />
        第三章 监管实施与流程​
        <br />
        第八条 监管方式​
        <br />
        日常检查：对被监管单位的技术管理制度、操作流程、质量记录等进行常规核查；​
        <br />
        抽样检测：随机抽取产品、样本或数据，委托专业机构进行技术性能与质量检验；​
        <br />
        专项督查：针对重点领域、突出问题或重大活动开展集中监管行动；​
        <br />
        动态监测：运用大数据、人工智能等技术，对技术活动数据进行实时分析与风险预警；​
        <br />
        社会监督：受理公众投诉举报，核查后依法处理并反馈结果。​
        <br />
        第九条 监管实施程序​
        <br />
        计划制定：监管部门于每年年底制定下一年度监管计划，向社会公开；​
        <br />
        通知与准备：实施检查前，书面告知被监管单位检查范围、依据与要求（突击检查除外）；​
        <br />
        现场实施：检查人员出示执法证件，采取现场核查、资料查阅、抽样取证等方式开展工作，如实记录检查情况；​
        <br />
        结果反馈：当场向被监管单位反馈初步意见，正式检查报告于检查结束后 15
        个工作日内送达；​
        <br />
        整改与复查：对发现的问题，下达《技术监督整改通知书》，明确整改要求与期限；整改完成后进行复查验收。​
        <br />
        第十条 新技术监管特别规定​
        <br />
        对人工智能、区块链、量子计算等新兴技术，实行 “包容审慎” 监管：​
        <br />
        建立技术伦理审查机制，重点评估公平性、透明性与安全性；​
        <br />
        采用 “沙盒监管” 模式，在可控范围内开展试点监测；​
        <br />
        参照国际通行标准，动态调整监管要求，防范技术风险。​
        <br />
        第四章 技术标准与风险防控​
        <br />
        第十一条 技术标准体系​
        <br />
        技术标准包括国家标准、行业标准、地方标准及团体标准，各类标准应当协调统一；​
        <br />
        对尚无国家标准的新兴技术领域，监管部门可制定临时技术要求，待条件成熟后上升为正式标准；​
        <br />
        鼓励企业制定高于法定标准的企业技术规范。​
        <br />
        第十二条 风险防控机制​
        <br />
        建立技术风险分级制度，根据风险程度划分为一般、较大、重大三个等级，实施差异化监管；​
        <br />
        被监管单位应当建立风险自查制度，定期排查技术隐患并报送自查报告；​
        <br />
        监管部门建立风险预警平台，对发现的共性风险及时发布预警信息，指导行业防控。​
        <br />
        第十三条 重大技术事故处理​
        <br />
        发生重大技术事故（如产品质量安全事故、技术系统崩溃等），被监管单位应当立即启动应急预案，并在
        2 小时内向监管部门报告；​
        <br />
        监管部门接到报告后，应当立即组织事故调查，明确责任主体与事故原因；​
        <br />
        依法对责任单位予以处罚，并向社会公开事故处理结果与整改要求。​
        <br />
        第五章 法律责任​
        <br />
        第十四条 被监管单位违法责任​
        <br />
        未建立内部技术管控体系、拒绝配合监管检查的，责令限期改正，并处 1
        万元以上 5 万元以下罚款；​
        <br />
        违反技术标准生产经营、提供虚假资料的，没收违法产品与违法所得，并处货值金额
        2 倍以上 10 倍以下罚款；情节严重的，吊销相关许可；​
        <br />
        未履行风险防控义务导致技术事故的，依法承担赔偿责任；构成犯罪的，追究刑事责任。​
        <br />
        第十五条 监管主体违法责任​
        <br />
        监管部门及其工作人员滥用职权、徇私舞弊的，对直接负责人员依法给予处分；构成犯罪的，追究刑事责任；​
        <br />
        专业技术机构出具虚假检测报告的，撤销其资质认证，没收违法所得，并处违法所得
        3 倍以上 5 倍以下罚款；对直接责任人予以终身行业禁入。​
        <br />
        第十六条 免责与从轻情形​
        <br />
        被监管单位主动发现并整改问题，未造成危害后果的，可从轻或免予处罚；​
        <br />
        因不可抗力导致技术合规问题的，依法减轻责任。​
        <br />
        第六章 保障与监督机制​
        <br />
        第十七条 保障措施​
        <br />
        经费保障：县级以上人民政府将技术监管经费纳入财政预算，保障监管设备购置、技术研发与机构运行；​
        <br />
        技术支撑：支持监管科技（RegTech）发展，推广大数据监测、区块链存证等先进监管手段；​
        <br />
        人才建设：建立监管专业人才库，开展法律法规与技术技能培训。​
        <br />
        第十八条 信息公开与公众参与​
        <br />
        监管部门应当通过官方平台公开技术标准、监管流程、检查结果与处罚决定；​
        <br />
        设立投诉举报热线与信箱，对实名举报予以回复，对查实的举报给予奖励；​
        <br />
        定期召开听证会或征求意见会，吸纳公众与企业对监管政策的建议。​
        <br />
        第十九条 监督与考核​
        <br />
        上级监管部门对下级部门的监管工作进行年度考核，考核结果纳入政府绩效评价；​
        <br />
        审计部门对监管经费使用情况进行审计监督；​
        <br />
        接受人大、政协及社会舆论对监管工作的监督。​
        <br />
        第七章 附则​
        <br />
        第二十条 术语定义​
        <br />
        技术活动：涉及技术研发、生产制造、服务提供、工程建设等的各类实践活动；​
        <br />
        技术标准：对技术活动中需要统一规范的技术要求所制定的准则；​
        <br />
        监管科技（RegTech）：运用信息技术提升监管效率与精准度的技术手段。​
        <br />
        第二十一条 施行日期​
        <br />
        本条例自发布之日起施行。此前发布的相关规定与本条例不一致的，以本条例为准。​
        <br />
        第二十二条 解释权​
        <br />
        本条例由县级以上人民政府技术监管主管部门负责解释。
      </div>
    </Modal>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      isModal: false,
      icpData: {
        name: '浙江微乐播信息科技有限公司',
        icp: '浙ICP备2022035194号',
        title: '浙江微乐播信息科技有限公司',
      },
    }
  },
  mounted() {
    const hostname = window.location.hostname

    switch (hostname) {
      case 'wlbhnab.cn':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号-7',
          title: '海南威乐播科技有限公司',
        }
        break
      case 'www.wlbhnab.cn':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号-7',
          title: '海南威乐播科技有限公司',
        }
        break
      case 'gdwlblive.com':
        this.icpData = {
          name: '广东微乐播科技有限公司',
          icp: '粤ICP备2024328631号-2',
          title: '广东微乐播科技有限公司',
        }
        break
      case 'www.gdwlblive.com':
        this.icpData = {
          name: '广东微乐播科技有限公司',
          icp: '粤ICP备2024328631号-2',
          title: '广东微乐播科技有限公司',
        }
        break
      case 'wlbhnlive.com':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号-6',
          title: '海南威乐播科技有限公司',
        }
        break
      case 'www.wlbhnlive.com':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号-6',
          title: '海南威乐播科技有限公司',
        }
        break
      case 'wlivelkhw.com':
        this.icpData = {
          name: '浙江乐康好物科技有限公司',
          icp: '浙ICP备2025156543号-3',
          title: '浙江乐康好物科技有限公司',
        }
        break
      case 'www.wlivelkhw.com':
        this.icpData = {
          name: '浙江乐康好物科技有限公司',
          icp: '浙ICP备2025156543号-3',
          title: '浙江乐康好物科技有限公司',
        }
        break
      case 'wlblive.com':
        this.icpData = {
          name: '微乐播小助手网站',
          icp: '浙ICP备2022035194号-10',
          title: '微乐播小助手网站',
        }
        break
      case 'www.wlblive.com':
        this.icpData = {
          name: '微乐播小助手网站',
          icp: '浙ICP备2022035194号-10',
          title: '微乐播小助手网站',
        }
        break
      case 'www.hnwlb.com':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号-5',
          title: '海南威乐播',
        }
        break
      case 'hnwlb.com':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号-5',
          title: '海南威乐播',
        }
        break
      case 'hainanweilebo.top':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号',
          title: '海南威乐播',
        }
        break
      case 'weileboo.top':
        this.icpData = {
          name: '广西南宁志捷网络科技有限公司',
          icp: '桂ICP备2022008688号-22',
          title: '广西南宁志捷网络科技有限公司',
        }
        break
      case 'weileboi.com.cn':
        this.icpData = {
          name: '广西南宁志捷网络科技有限公司',
          icp: '桂ICP备2022008688号-19',
          title: '广西南宁志捷网络科技有限公司',
        }
        break
      case 'hainweilebo.top':
        this.icpData = {
          name: '海南威乐播科技有限公司',
          icp: '琼ICP备2023003446号-3',
          title: '海南威乐播',
        }
        break
      case 'hzvlebo.top':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-7',
          title: '微乐播门户网站',
        }
        break
      case 'www.hzvlebo.top':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-7',
          title: '微乐播门户网站',
        }
        break
      case 'www.weilebo.cn':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-2',
          title: '微乐播门户网站',
        }
        break
      case 'weilebo.cn':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-2',
          title: '微乐播门户网站',
        }
        break
      case 'tangcuifang.com':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-1',
          title: '浙江微乐播信息科技有限公司',
        }
        break
      case 'www.tangcuifang.com':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-1',
          title: '浙江微乐播信息科技有限公司',
        }
        break
      case 'www.vqwelqwebo.cn':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-14',
          title: '微乐播',
        }
        break
      case 'vlebo.tv':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-20',
          title: '微乐播',
        }
        break
      case 'www.vlebo.tv':
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号-20',
          title: '微乐播',
        }
        break
      default:
        this.icpData = {
          name: '浙江微乐播信息科技有限公司',
          icp: '浙ICP备2022035194号',
          title: '浙江微乐播信息科技有限公司',
        }
    }

    document.title = this.icpData.title
  },
  methods: {},
}
</script>

<style lang="scss" scoped></style>
<style lang="scss" scoped>
.m-footer {
  width: 100%;
  text-align: center;
  // position: absolute;
  bottom: 0;
  left: 0;
  font-size: 14px;
}

.bottom-ul {
  display: inline-block;
  width: 675px;
  height: 100px;
  text-align: center;
  line-height: 100px;
}

.bottom-ul li {
  float: left;
  list-style: none;
}

.link {
  margin-right: 0;
}
</style>
